//@flow
import axios from "axios"
// import Interceptors from "./interceptors"
import { HttpConfig } from "./http-config"
import {v4 as uuidv4} from "uuid"

const HttpVerb = Object.freeze({ POST: "POST", GET: "GET", PUT: "PUT", PATCH: "PATCH", DELETE: "DELETE" })
const API_ROOT = process.env.REACT_APP_PROFILE_API_URL
const defaultHeaders = {
    "Content-Type": "application/json"
}

export class HttpClient {
  _client
  _cancelTokens = {}
  static instance

  constructor() {
    if (!HttpClient.instance) {
      this._client = axios.create({
        baseURL: API_ROOT,
        timeout: HttpConfig.DefaultTimeout,
        withCredentials: true
      })
      this._cancelTokens = {}
      HttpClient.instance = this
    }
  }

  cancelRequests(requests = []) {
    requests.forEach(requestName => {
      if (this._cancelTokens[requestName]) {
        this._cancelTokens[requestName].abort()
        delete this._cancelTokens[requestName]
      }
    })
  }
   
  getCancelToken(requestName) {    
    if (this._cancelTokens[requestName]) {
      // Cancel original request so we don't get overlapping data
      this._cancelTokens[requestName].abort()
    }
    
    const cancelation = new AbortController()
    this._cancelTokens[requestName] = cancelation
    return cancelation
  }

  createRequest(config) {   
    const id = uuidv4()
    return { id, config }
  }

  request(request) {
    return this._client(request.config)
      .then(response => {
        const { data } = response
        return { data, request }
      })
      .catch(error => {
        return Promise.reject(error)
      })
  }

  // #region HttpMethods

  post(baseURL, url, payload = {}, customHeaders = {}, otherConfig = {}) {
    const config = {
      baseURL: baseURL || this._client.defaults.baseURL,
      url: url,
      method: HttpVerb.POST,
      headers: {
        ...defaultHeaders,
        ...customHeaders
      },
      ...otherConfig,
      data: payload
    }

    return this.request(this.createRequest(config))
  }
  
  get(baseURL, url, options = {}) {
    let signal = null

    if (options.name) {     
      const cancelation = this.getCancelToken(options.name)
      signal = cancelation.signal
    }
    const config = {
      baseURL: baseURL || this._client.defaults.baseURL,
      url: url,
      method: HttpVerb.GET,
      signal,
      headers: { ...options?.customHeaders ?? [] },
      ...options?.otherConfig ?? []
    }

    return this.request(this.createRequest(config))
  } 

  put(baseURL, url, payload = {}, customHeaders = {}, otherConfig = {}) {
    const config = {
      baseURL: baseURL || this._client.defaults.baseURL,
      url: url,
      method: HttpVerb.PUT,
      headers: {
        ...defaultHeaders,
        ...customHeaders
      },
      ...otherConfig,
      data: payload
    }

    return this.request(this.createRequest(config))
  }

  delete(baseURL, url, payload = {}, customHeaders = {}) {
    const config = {
      baseURL: baseURL || this._client.defaults.baseURL,
      url: url,
      method: HttpVerb.DELETE,
      headers: {
        ...defaultHeaders,
        ...customHeaders
      },
      data: payload
    }

    return this.request(this.createRequest(config))
  }

  // #endregion
}

const instance = new HttpClient()
Object.freeze(instance)

export { HttpVerb }
export default instance
